<template>
  <div>
    <div class="box">
      <!-- <button class="backBtn" @click="back()">返回上级</button> -->
      <div ref="mapdd" class="chart"></div>
    </div>
  </div>
</template>
<script>
import cityMap from "./js/china-main-city-map"; //展示每个省的id
import * as echarts from "echarts";
import axios from "axios";
// import { getPoint } from "/@/api/homeApi";

//中国地图（第一级地图）的ID、Name、Json数据
// var chinaId = 100000;
// var chinaName = "china";
var chinaId = 530000;
var chinaName = "yunnan";
var chinaJson = null; 

//记录父级ID、Name
var mapStack = [];
var parentId = null;
var parentName = null;

//Echarts地图全局变量，主要是在返回上级地图的方法中会用到
var myChart = null;
var aaa = "111";
export default {
  name: "chinaMap",
  props: {
    msg: String,
  },
  data() {
    return {
      radio: "全部应用",
      mapDate6: [],
    };
  },
  mounted() {
    // this.getallpoints({})
    this.mapChart();
  },
  methods: {
    //这是接口获取点位坐标 返回的是经纬度的
    // getallpoints(param) {
    //   let res = getPoint({
    //     ...param,
    //   });
    //   res.then((res) => {
    //     this.mapDate6 = res.data;
    //     this.mapDate6.forEach((item)=>{
    //       item.name = item.province
    //     })
    //     this.mapChart();//获取数据成功构建地图
    //   }).catch(()=>{
    //     this.mapChart();//如果没有网络也让构建地图
    //   });
    // },

    // 返回上一级地图
    back() {
      if (mapStack.length != 0) {
        //如果有上级目录则执行
        var map = mapStack.pop();
        axios
          .get(systemConfig.mapJsonUrl + map.mapId + ".json", {})
          .then((response) => {
            const mapJson = response.data;
            this.getecharts(myChart, map.mapId, map.mapName, mapJson, false);
            parentId = map.mapId;
            parentName = map.mapName;
          });
      }
    },
    //获取本地地图信息
    mapChart() {
      axios
        .get(systemConfig.mapJsonUrl + chinaId + ".json")
        .then((response) => {
          const mapJson = response.data;
          chinaJson = mapJson;
          myChart = echarts.init(this.$refs.mapdd);
          this.getecharts(myChart, chinaId, chinaName, mapJson, false);
          parentId = chinaId;
          parentName = "yunnan";
          myChart.on("click", (param) => {
            var cityId = cityMap[param.name];
            if (cityId) {
              //代表有下级地图
              axios
                .get(systemConfig.mapJsonUrl + cityId + ".json", {})
                .then((response) => {
                  const mapJson = response.data;
                  this.getecharts(myChart, cityId, param.name, mapJson, true);
                });
            } else {
              //没有下级地图，回到一级中国地图，并将mapStack清空
              this.getecharts(myChart, chinaId, chinaName, chinaJson, false);
              mapStack = [];
              parentId = chinaId;
              parentName = chinaName;
            }
          });
          myChart.on("mouseover", function (params) {
            //console.log(params); //这里的params是鼠标悬浮的图表节点的数据
          });
          window.addEventListener("resize", function () {
            myChart.resize();
          });
        })
        .catch((res) => {
          // console.log("错误信息", res);
        });
    },
    //echarts构建地图和点位信息
    getecharts(myChart, id, name, mapJson, flag) {
      console.log(mapJson, "mapJson");
      echarts.registerMap(name, { geoJSON: mapJson });
      myChart.setOption({
        baseOption: {
          geo: {
            map: name,
            aspectScale: 0.75,
            zoom: 1.2,
            layoutSize: "100%",
            label: {
              color: "#fff",
            },
            itemStyle: {
              areaColor: {
                type: "radial",
                x: 0.5,
                y: 0.5,
                r: 0.8,
                colorStops: [
                  {
                    offset: 0,
                    color: "#bee8ff", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#bee8ff", // 100% 处的颜色
                  },
                ],
                globalCoord: true, // 缺省为 false
              },
            },
          },
          tooltip: {
            trigger: "item",
          },
          series: [
            {
              type: "map",
              map: name,
              //   scale: true,
              //   roam: true,
              //   move: true,
              zoom: 1.2,
              tooltip: {
                trigger: "item",
                formatter: function (params, ticket, callback) {
                  return (
                    params.name + "<br>行政区划代码：" + cityMap[params.name]
                  );
                },
              },
              //每一块区域的颜色
              itemStyle: {
                normal: {
                  label: { show: true },
                  borderColor: "#6cb8ed",
                  borderWidth: 2,
                  areaColor: {
                    type: "radial",
                    x: 0.5,
                    y: 0.5,
                    r: 0.8,
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(175,238,238, 0)", // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "rgba(47,79,79, .1)", // 100% 处的颜色
                      },
                    ],
                    globalCoord: true, // 缺省为 false
                  },
                  shadowColor: "rgba(128, 217, 248, 1)", //阴影的颜色
                  shadowOffsetX: -2,
                  shadowOffsetY: 2,
                  shadowBlur: 10,
                },
                // 鼠标当前所在的区域块的相关设置
                emphasis: {
                  areaColor: "rgba(60, 243, 209,0.7)", //区域块的颜色
                  borderWidth: 2,
                  textStyle: {
                    color: "#fff",
                  },
                },
              },

              label: {
                normal: {
                  textStyle: {
                    fontSize: 8,
                    fontWeight: "bold",
                    color: "#200101",
                  },
                },
                emphasis: {
                  textStyle: {
                    color: "#fff",
                    fontSize: 16,
                  },
                },
              },
              layoutCenter: ["50%", "80%"], //地图位置
              regions: [
                {
                  name: "南海诸岛",
                  value: 0,
                  itemStyle: {
                    normal: {
                      opacity: 0,
                    },
                  },
                },
              ],
              data: this.initmapdata(mapJson),
            },
            {
              name: "点位",
              type: "effectScatter",
              coordinateSystem: "geo",
              data: this.mapDate6,
              symbolSize: 20,

              hoverAnimation: true,
              itemStyle: {
                normal: {
                  color: "#f77214",
                  shadowBlur: 10,
                  shadowColor: "#333",
                },
              },
              zlevel: 1,
            },
          ],
        },
      });

      if (flag) {
        //往mapStack里添加parentId，parentName,返回上一级使用
        mapStack.push({
          mapId: parentId,
          mapName: parentName,
        });
        parentId = id;
        parentName = name;
      }
    },

    initmapdata(mapJson) {
      var mapData = [];
      for (var i = 0; i < mapJson.features.length; i++) {
        mapData.push({
          name: mapJson.features[i].properties.name,
        });
      }
      return mapData;
    },
  },
};
</script>
<style scoped>
.box {
  width: 100%;
  height: 100%;
}
.chart {
  width: 100%;
  height: 100%;
}
</style>